import React from "react";
import { styled } from "@mui/system";

const CarouselWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-evenly",
}));

const Carousel = styled("div")(({ theme }) => ({
  width: "90vw",
  display: "flex",
  overflowX: "scroll",
  scrollBehavior: "smooth",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const Item = styled("div")(({ theme }) => ({
  flexBasis: "20%",
  flexShrink: 0,
  padding: "1rem",
  [theme.breakpoints.down("sm")]: {
    flexBasis: "50%",
  },
}));

const Button = styled("button")({
  border: "none",
  backgroundColor: "transparent",
  cursor: "pointer",
  color: "brown",
  fontSize: "5rem",
  overflow: "hidden",
  zIndex: 100,
});

const Image = styled("img")(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    width: "50%",
  },
}));

const CarouselComp = () => {
  //   const [currentIndex, setCurrentIndex] = React.useState(0);

  //   const handlePrev = () => {
  //     setCurrentIndex((prevIndex) =>
  //       prevIndex === 0 ? slides.length - 1 : prevIndex - 1
  //     );
  //   };

  //   const handleNext = () => {
  //     setCurrentIndex((prevIndex) =>
  //       prevIndex === slides.length - 1 ? 0 : prevIndex + 1
  //     );
  //   };

  return (
    <CarouselWrapper>
      <Button>Left</Button>
      <Carousel>
        <Item>
        </Item>
        {/* More items... */}
      </Carousel>
      <Button className="right">Right</Button>
    </CarouselWrapper>
  );
};

export default CarouselComp;
